import React from 'react';
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t } = useTranslation();
  return (
    <h1 className="c-title--main border">
      {t("Frequently asked questions on products")}
    </h1>
  );
};

export default Header;
